module.exports = __webpack_public_path__ + "bm.dbd36ba3ab7d440612df.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bm.svg
// module chunks = styles